export default __webpack_public_path__ + "static/media/gradle.6796b028.svg";